// src/services/pagesService.js
import apiClient from './apiClient.js'

export const pagesService = {
    getPages() {
        return apiClient.get('/pages')
    },

    getPageBySlug(slug) {
        return apiClient.get(`/pages/${slug}`)
    },

    createPage(data) {
        return apiClient.post('/pages', data)
    },

    updatePage(slug, data) {
        return apiClient.put(`/pages/${slug}`, data)
    },

    updateSection(slug, sectionKey, data) {
        return apiClient.put(`/pages/${slug}/sections/${sectionKey}`, data)
    },

    toggleSectionVisibility(slug, sectionKey, isVisible) {
        return apiClient.put(`/pages/${slug}/sections/${sectionKey}/visibility`, { isVisible })
    },
}